// locationValidation.js
export const validateLocationHours = (data) => {
    const errors = {};
    
    // Validate address only if it's a physical business
    if (data.businessType === 'physical' && !data.address?.trim()) {
      errors.address = 'Physical business address is required';
    }
    
    // Business hours validation removed - now optional in additionalInfo field
    
    return errors;
  };